
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Operacion , ControladorInterfaz} from '@/views/a-pedidos-ml/pc/facturacion/controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Operacion: Operacion;

        @Prop()
        public Controlador: ControladorInterfaz;



        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Operacion.onEstado.subscribe( () => { this.$emit( 'refrescar' ); } ) );
            await this.Operacion.Iniciar();
        }

        public async AbrirFactura()
        {

            //this.Cargando = true;
            let pdf = await Pedido.URLFacturas( [this.Operacion.Pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la factura` );

            }
            //this.Cargando = false;
        }

    }
